const closeClass = 'd-none';

class Close {
    constructor(closeTrigger) {
        this.closeTrigger = closeTrigger;
    }

    static handleClose(closeTrigger) {
        const closeTargetId = closeTrigger.dataset.closeTarget;

        if (typeof closeTargetId === 'undefined') {
            return;
        }

        const closeTarget = document.getElementById(closeTargetId);

        if (closeTarget === null) {
            return;
        }

        closeTrigger.addEventListener('click', () => {
            if (!closeTarget.classList.contains(closeClass)) {
                closeTarget.classList.add(closeClass);
            }
        });
    }

    init() {
        this.constructor.handleClose(this.closeTrigger);
    }
}

export default Close;
